export const FirebaseConfig = {
	"projectId": "jaretransit-exicube",
	"appId": "1:218210305042:web:242ecf0a5c74dc482684cb",
	"databaseURL": "https://jaretransit-exicube-default-rtdb.firebaseio.com",
	"storageBucket": "jaretransit-exicube.firebasestorage.app",
	"apiKey": "AIzaSyC9Kj2BTxG6MyhRAWxsRcHUOdWVox66mco",
	"authDomain": "jaretransit-exicube.firebaseapp.com",
	"messagingSenderId": "218210305042",
	"measurementId": "G-XJ49CPWGG2",
	"projectNumber": "218210305042",
	"version": "2"
};